import type { ReactNode } from 'react';

export const symbol_auto_read_play: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m442-435 158-106q10-6.8 10-18.9 0-12.1-10-19.1L442-685q-11-8-23-1.44-12 6.55-12 20.44v213q0 14 12 20t23-2ZM240-240 131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H240Zm-26-60h606v-520H140v600l74-80Zm-74 0v-520 520Z"
		/>
	</svg>
);
